import baseStyles from '@ts-core/styles/baseStyles';

const styles = (theme) => ({
  ...baseStyles(theme),
  titleContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
});

export default styles;
